import React, { useContext, useState } from "react";
import * as FaIcons from "react-icons/fa";
import RegistrationContext from "../../../context/registration/registrationContext";
import { useEffect } from "react";
import SubFormButtons from "../SubFormButtons";
import ProgressButtons from "../ProgressButtons";

const R14HealthConditions = () => {
  const registrationContext = useContext(RegistrationContext);
  const {
    // onFormDataChange,,
    subFormLevels,
    formData: {
      firstName,
      knownHealthConditions,
      knownHearingConditions,
      wearsHearingAid,
      knownEyeCondition,
      medications,
      otherHealthCondition,
      heathInsuranceCarrier,
      insuranceIdOrPolicyNumber,
      hospitalPreference,
      medicalInstructions,
    },
    onFormDataChange,
    pass: { healthConditions },
  } = registrationContext;

  const handleChange = (e) => {
    const value = e.target.value;
    e.target.value =
      value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    onFormDataChange(e);
  };

  const Healthcondition =
    knownHealthConditions !== "" &&
    knownHearingConditions !== "" &&
    (knownHearingConditions["no"] ||
      (knownHearingConditions["yes"] && wearsHearingAid !== "")) &&
    knownEyeCondition !== "";

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <>
      <div className="sub-form">
        <h2 className="">
          Health Conditions <span>(13/15)</span>
          <hr />{" "}
        </h2>
        <div className="item">
          <div className="asterisk-group">
            <h3>
              Does {firstName === "" ? "the Student" : firstName} Have Any known
              Health Conditions?{" "}
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border: healthConditions
                ? "1px solid #ccc;"
                : knownHealthConditions !== ""
                ? "1px solid #ccc"
                : "#d8302f 2px solid",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={knownHealthConditions["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="knownHealthConditions"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={knownHealthConditions["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="knownHealthConditions"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>
              Does {firstName === "" ? "the Student" : firstName} Have Any Known
              Hearing Problems?{" "}
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border: healthConditions
                ? "1px solid #ccc;"
                : knownHearingConditions !== ""
                ? "1px solid #ccc"
                : "#d8302f 2px solid",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={knownHearingConditions["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="knownHearingConditions"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={knownHearingConditions["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="knownHearingConditions"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>

        {knownHearingConditions["yes"] && (
          <div className="item">
            <div className="asterisk-group">
              <h3>
                Does {firstName === "" ? "the Student" : firstName} Wear a
                Hearing Aid?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <div
              className="flex-check-container"
              style={{
                border: healthConditions
                  ? "1px solid #ccc;"
                  : wearsHearingAid !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={wearsHearingAid["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="wearsHearingAid"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={wearsHearingAid["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="wearsHearingAid"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>
        )}

        <div className="item">
          <div className="asterisk-group">
            <h3>
              Does {firstName === "" ? "the Student" : firstName} Have Any known
              Eye Conditions?{" "}
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border: healthConditions
                ? "1px solid #ccc;"
                : knownEyeCondition !== ""
                ? "1px solid #ccc"
                : "#d8302f 2px solid",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={knownEyeCondition["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="knownEyeCondition"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={knownEyeCondition["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="knownEyeCondition"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>
              Does {firstName === "" ? "the Student" : firstName} Have Any
              Medications?
            </h3>
          </div>
          <input
            type="text"
            name="medications"
            onChange={(e) => handleChange(e)}
            value={medications}
          />
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>
              Does {firstName === "" ? "the Student" : firstName} Have Any Other
              Health Conditions?
            </h3>
          </div>
          <input
            type="text"
            name="otherHealthCondition"
            onChange={(e) => handleChange(e)}
            value={otherHealthCondition}
          />
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>
              Does {firstName === "" ? "the Student" : firstName} Have Any
              Medical Instructions?
            </h3>
          </div>
          <input
            type="text"
            name="medicalInstructions"
            onChange={(e) => handleChange(e)}
            value={medicalInstructions}
          />
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>
              What Is {firstName === "" ? "the Student" : firstName}'s Health
              Insurance Carrier?
            </h3>
          </div>
          <input
            type="text"
            name="heathInsuranceCarrier"
            onChange={(e) => handleChange(e)}
            value={heathInsuranceCarrier}
          />
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>
              What Is {firstName === "" ? "the Student" : firstName}'s Insurance
              ID or Policy #?
            </h3>
          </div>
          <input
            type="text"
            name="insuranceIdOrPolicyNumber"
            onChange={(e) => handleChange(e)}
            value={insuranceIdOrPolicyNumber}
          />
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>
              What Is {firstName === "" ? "the Student" : firstName}'s Hospital
              Preference?
            </h3>
          </div>
          <input
            type="text"
            name="hospitalPreference"
            onChange={(e) => handleChange(e)}
            value={hospitalPreference}
          />
        </div>
        <div className="group">
          <div>{subFormLevels.healthConditions === 0}</div>
        </div>
      </div>
      <ProgressButtons validation={Healthcondition} name="healthConditions" />
    </>
  );
};
export default R14HealthConditions;
